import { render, staticRenderFns } from "./witness.vue?vue&type=template&id=7e20c754&scoped=true&"
import script from "./witness.vue?vue&type=script&lang=js&"
export * from "./witness.vue?vue&type=script&lang=js&"
import style0 from "./witness.vue?vue&type=style&index=0&id=7e20c754&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e20c754",
  null
  
)

export default component.exports